import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {map, Observable, tap } from 'rxjs';

@Injectable()
export class CountryCodeService {

    private codes: any = {};

    constructor(private $http: HttpClient) { }

    loadCodes(): Observable<boolean> {
        return this.$http.get('/assets/data/country.codes.json').pipe(
            tap(result => {
                this.codes = result;
            }),
              map(result => true));
    }

    getCode(country: string): string {
        let code = country;
        const obj = this.codes[country];
        if (obj) {
            code = obj.code;
        }
        return code;
    }

}
